module.exports = __webpack_public_path__ + "static/img/hero-bg-11529d.048d9ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/help/hero-bg-11529d.png
// module id = Mvdl
// module chunks = 1